export default __webpack_public_path__ + "static/media/axie-logo.49202a3b.png";